import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const FormError = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* ERROR MESSAGES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-red-400 mb-6"> Error Messages</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Error</label>
            <input type="text" className="w-full px-3 py-2 border-2 border-red-500 rounded-lg bg-slate-950" value="" readOnly />
            <p className="text-xs text-red-500 mt-1"> This field is required</p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input className="border-2 border-red-500" />
<p className="text-xs text-red-500"> This field is required</p>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Invalid Email</label>
            <input type="email" className="w-full px-3 py-2 border-2 border-red-500 rounded-lg bg-slate-950" value="invalid@" readOnly />
            <p className="text-xs text-red-500 mt-1"> Please enter a valid email</p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="email" className="border-2 border-red-500" />
<p className="text-red-500">Invalid email format</p>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Password Weak</label>
            <input type="password" className="w-full px-3 py-2 border-2 border-orange-500 rounded-lg bg-slate-950" value="123" readOnly />
            <p className="text-xs text-orange-500 mt-1"> Password is too weak</p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input type="password" className="border-2 border-orange-500" />
<p className="text-orange-500"> Password is too weak</p>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Multiple Errors</label>
            <div>
              <input type="text" className="w-full px-3 py-2 border-2 border-red-500 rounded-lg bg-slate-950 mb-2" placeholder="Name" readOnly />
              <ul className="text-xs text-red-500 space-y-1">
                <li> Required field</li>
                <li> Must be at least 3 characters</li>
              </ul>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input className="border-2 border-red-500" />
<ul className="text-red-500">
  <li>Required field</li>
  <li>Must be 3+ chars</li>
</ul>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Error with Icon</label>
            <input type="text" className="w-full px-3 py-2 border-2 border-red-500 rounded-lg bg-slate-950" readOnly />
            <div className="flex items-center mt-1 text-xs text-red-500">
              <span className="mr-1"></span>
              <span>Field validation failed</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex items-center text-red-500">
  <span className="mr-1"></span>
  <span>Validation failed</span>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Inline Error</label>
            <div className="flex gap-2">
              <input type="text" className="flex-1 px-3 py-2 border-2 border-red-500 rounded-lg bg-slate-950" readOnly />
              <span className="text-red-500 font-bold text-xl">!</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-2">
  <input className="border-2 border-red-500" />
  <span className="text-red-500">!</span>
</div>`} />
          </div>
        </div>
      </div>

      {/* SUCCESS, WARNING, INFO */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-green-400 mb-6"> Success & Other States</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Success State</label>
            <input type="text" className="w-full px-3 py-2 border-2 border-green-500 rounded-lg bg-slate-950" value="valid@email.com" readOnly />
            <p className="text-xs text-green-500 mt-1"> Email verified</p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input className="border-2 border-green-500" />
<p className="text-green-500"> Email verified</p>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Warning State</label>
            <input type="text" className="w-full px-3 py-2 border-2 border-amber-500 rounded-lg bg-slate-950 bg-opacity-50" value="admin@old-domain.com" readOnly />
            <p className="text-xs text-amber-500 mt-1"> Domain is deprecated</p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input className="border-2 border-amber-500" />
<p className="text-amber-500"> Warning message</p>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Info Message</label>
            <input type="text" className="w-full px-3 py-2 border-2 border-blue-500 rounded-lg bg-slate-950" value="" readOnly />
            <p className="text-xs text-blue-500 mt-1">? Consider using a strong password</p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<input className="border-2 border-blue-500" />
<p className="text-blue-500">? Info message</p>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Error Block</label>
            <div className="p-3 bg-red-950 border-l-4 border-red-500 rounded">
              <p className="text-sm text-red-300 font-medium">Error</p>
              <p className="text-xs text-red-200">Something went wrong. Please try again.</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-3 bg-red-950 border-l-4 border-red-500">
  <p className="text-red-300">Error</p>
  <p className="text-red-200">Message</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Toast-like Error</label>
            <div className="p-3 bg-red-900 rounded-lg flex justify-between items-center">
              <span className="text-sm text-red-200"> Error uploading file</span>
              <button className="text-red-300 hover:text-red-100"></button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-3 bg-red-900 rounded-lg flex justify-between">
  <span className="text-red-200">Error message</span>
  <button></button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Animated Error</label>
            <div className="p-3 bg-red-950 border-2 border-red-500 rounded-lg animate-pulse">
              <p className="text-sm text-red-300"> Validating...</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-3 bg-red-950 border-2 border-red-500 animate-pulse">
  <p className="text-red-300">Validating...</p>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormError;


